// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"05a94f47","647":"8403f117"}[chunkId] + ".chunk.js";
};